import styled from 'styled-components';

export const SearchContainer = styled.div`
  .search-modal {
    .modal-content {
      border-radius: 12px;
      box-shadow: 0 8px 24px rgba(0,0,0,0.1);
    }
  }

  .modal-header {
    background: #f8f9fa;
    border-bottom: 2px solid #e9ecef;
    border-radius: 12px 12px 0 0;
    padding: 1.5rem;
  }

  .modal-title {
    font-weight: 600;
    color: #2c3038;
  }

  .search-controls {
    background: #fff;
    border-radius: 8px;
    padding: 1.25rem;
    margin-bottom: 1.5rem;
    box-shadow: 0 2px 4px rgba(0,0,0,0.03);
  }
  .search-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    
    .search-icon {
      position: absolute;
      left: 12px;
      top: 50%;
      transform: translateY(-50%);
      color: #6c757d;
      font-size: 14px;
      z-index: 2;
    }

    input {
      width: 100%;
      height: 36px;
      padding: 8px 12px 8px 35px;
      border: 1px solid #e9ecef;
      border-radius: 6px;
      transition: all 0.2s;
      font-size: 14px;
      
      &:focus {
        outline: none;
        border-color: #80bdff;
        box-shadow: 0 0 0 0.2rem rgba(0,123,255,0.1);
      }

      &::placeholder {
        color: #adb5bd;
      }
    }
  }

  .search-options {
    label {
      margin-right: 1.5rem;
      cursor: pointer;
      
      input {
        margin-right: 0.5rem;
      }
    }
  }
  .table-container {
    border-radius: 8px;
    margin-bottom: 1.5rem;
    overflow: hidden;
    border: 1px solid #e9ecef;

    table {
      margin-bottom: 0;
      
      th {
        background: #f8f9fa;
        font-weight: 600;
        padding: 8px 12px;
        color: #495057;
        border-bottom: 2px solid #e9ecef;
        white-space: nowrap;
        cursor: pointer;
        transition: all 0.2s;
        font-size: 13px;
        text-transform: uppercase;
        letter-spacing: 0.3px;

        &:hover {
          background: #eef2f7;
        }

        .sort-icon {
          margin-left: 4px;
          opacity: 0.7;
        }
      }

      td {
        padding: 6px 12px;
        vertical-align: middle;
        border-bottom: 1px solid #f0f0f0;
        font-size: 13px;
        line-height: 1.2;
      }

      tbody tr {
        transition: all 0.2s;
        cursor: pointer;

        &:hover {
          background-color: #f8f9ff;
        }

        &.selected-row {
          background-color: #e7f1ff;
          
          td {
            border-color: #c2d9ff;
          }

          &:hover {
            background-color: #dceaff;
          }
        }
      }
    }
  }

  .pagination-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.03);

    .page-size-selector {
      display: flex;
      align-items: center;
      gap: 0.5rem;

      select {
        width: 70px;
        padding: 0.25rem;
        border-radius: 4px;
        border: 1px solid #dee2e6;
      }
    }

    .total-count {
      color: #6c757d;
      font-size: 0.875rem;
    }
  }

  .pagination {
    margin-bottom: 0;
    
    .page-link {
      padding: 0.375rem 0.75rem;
      border-radius: 4px;
      margin: 0 2px;
      color: #007bff;
      border: 1px solid #dee2e6;
      
      &:hover {
        background: #e9ecef;
        border-color: #dee2e6;
      }
    }

    .active .page-link {
      background: #007bff;
      border-color: #007bff;
    }
  }

  .image-preview {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    background: #fff;
    padding: 1rem;
    text-align: center;

    img {
      max-width: 100%;
      height: auto;
      border-radius: 4px;
    }
  }
`;
